export const makeImageAsset = ({
  src,
  src2x = src,
  alt,
  srcWidth,
  src2xWidth = srcWidth,
}) => ({
  src,
  src2x,
  full: src2x,
  alt,
  srcSet: `${src} 1x, ${src2x} 2x`,
  widthSrcSet: srcWidth
    ? `${src} ${srcWidth}w, ${src2x} ${src2xWidth}w`
    : `${src} 1x, ${src2x} 2x`,
});
